import * as ContextTypes from './ContextTypes';

export const hideOpenInAppMsgAction = (dispatch) => {
  dispatch({
    type: ContextTypes.HIDE_OPEN_IN_APP_MSG,
  });
};
